import { addParameterToURL } from "bm-ui-kit";
import type { PersonalLoanRequest, PersonalLoanResponseItem } from "../types";

export function convertErsteData(
	request: PersonalLoanRequest,
	response: PersonalLoanResponseItem,
): PersonalLoanResponseItem {
	const productData = { ...response };

	if (productData.marketing?.newTargetUrl) {
		productData.marketing.newTargetUrl = addParameterToURL(productData.marketing.newTargetUrl, {
			params: `osszeg_${request.loanAmount}__ido_${request.maturityYears * 12}__jov_${request.incomeList.reduce(
				(sum, income) => sum + income.amount,
				0,
			)}__mvisz_${request.incomeList.some((income) => income.durationMonths >= 3) ? 7 : 1}`,
		});
	}

	return productData;
}
